import Marquee from "react-fast-marquee";
import { FadeIn } from "@/components/FadeIn";

const IMAGES = [
  "/assets/gallery/01.jpg",
  "/assets/gallery/02.jpg",
  "/assets/gallery/03.jpg",
  "/assets/gallery/04.jpg",
  "/assets/gallery/05.jpg",
];

export default function GalleryStrip() {
  return (
    <section data-testid="gallery-strip" className="relative bg-[#050505] overflow-hidden border-t border-[#c9a14a]/15">
      <div className="absolute inset-0 grain pointer-events-none" aria-hidden="true" />
      <div className="relative py-16 md:py-20">
        <FadeIn className="text-center px-5">
          <p className="overline text-[#c9a14a]">Gallery</p>
          <h2 className="mt-3 font-serif-display text-3xl sm:text-4xl text-[#f7f2e8]">
            Moments at <span className="text-[#c9a14a]">Carlton</span>
          </h2>
        </FadeIn>
        <div className="mt-12">
          <Marquee speed={35} gradient={false} pauseOnHover>
            {IMAGES.map((src, i) => (
              <div
                key={src}
                data-testid={`gallery-image-${i}`}
                className="mx-3 rounded-xl overflow-hidden border border-[#c9a14a]/20"
              >
                <img
                  src={src}
                  alt="Carlton Wellness Center gallery"
                  loading="lazy"
                  className="h-44 md:h-60 w-auto object-cover aspect-[4/3] hover:scale-[1.04] transition-transform duration-700"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
